import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';

import { IconComponent } from '../../../../base-components/icon/icon.component';

@Component({
  selector: 'app-tile',
  imports: [RouterModule, TranslatePipe, IconComponent],
  templateUrl: './app-tile.component.html',
  styleUrls: ['./app-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppTileComponent {
  public icon = input.required<string>();
  public color = input.required<string>();
  public title = input.required<string>();
  public subtitle = input<string>('');
  public link = input.required<string>();
  public isSmall = input<boolean>(false);
  public action = input<string>('');
  public actionTriggered = output<void>();

  public onActionClick(event: Event): void {
    if (this.action()) {
      event.preventDefault();
      this.actionTriggered.emit();
    }
  }
}
